
// npm
import PropTypes from 'prop-types'

const ID_TYPE = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

export {ID_TYPE}